import { Injectable } from '@angular/core';
import { RequestService } from '@commonServices/request.service';
import { environment } from '@environments/environment';
import { Client as CatalogApi } from '@interfaces/HttpClient/CatalogApiPublicModels';
import { firstValueFrom } from 'rxjs';
import { TranslationService } from './translation.service';

@Injectable({
	providedIn: 'root'
})
export class HelpdeskService {

	constructor(
		private catalogApi: CatalogApi,
		private translationService: TranslationService,
		private requestService: RequestService
	) { }

	async getUseNewHelpdesk(): Promise<boolean> {
		// Keinen Backendcall auf Prod verschwenden
		if (environment.useNewHelpdesk === false)
			return false;

		try {
			return firstValueFrom(this.catalogApi.common_GetUseNewHelpdesk());
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getHelpdeskContent(solution: string, helpId: string): Promise<string> {
		try {
			return firstValueFrom(this.catalogApi.common_GetHelpdeskContent(solution, helpId, this.translationService.getLanguage().toUpperCase()));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getHelpdeskRoute(solution: string, helpId: string): Promise<string> {
		try {
			return firstValueFrom(this.catalogApi.common_GetHelpdeskRoute(solution, helpId, this.translationService.getLanguage().toUpperCase()));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}


}
